import { ILocation3 } from "@mobx/store/locations/types";
import { getSavedLocationsPositions, LOCATIONS_POS_KEY } from "@utils/saveLocationsPositions";

export const saveLocationsPos3 = (locs: number[], key: string) => {
  const ids = locs.join(",");
  
  const bytes = new TextEncoder().encode(ids);
  const binary = Array.from(bytes, byte => String.fromCharCode(byte)).join('');
  const encoded = btoa(binary);
  
  localStorage.setItem(`${LOCATIONS_POS_KEY}${key}`, encoded);
};

export const checkingLocationsPositions3 = (
  key: string,
  locs?: ILocation3[]
) => {
  if (!locs || !locs.length) return [];
  const savedPositions = getSavedLocationsPositions(key);
  if (!savedPositions) return locs;

  let filtered = [...locs];
  const currentPositions: ILocation3[] = [];

  savedPositions?.forEach((sp) => {
    const index = filtered.findIndex((item) => `${item.Id}` === `${sp}`);
    if (index === -1) return;
    currentPositions.push(filtered[index]);
    filtered = [...filtered.slice(0, index), ...filtered.slice(index + 1)];
  });

  // возвращаем все что мы запушили в верном порядке + то, что осталось в настройках
  // это на случай если добавлены новыйе настройки, а порядок не сохранен
  //console.log("CHECK LOCPOS 3", currentPositions, filtered);
  return [...currentPositions, ...filtered];
};
